import { render } from "./BlogStyleTwo.vue?vue&type=template&id=3a9bbb4c"
import script from "./BlogStyleTwo.vue?vue&type=script&lang=js"
export * from "./BlogStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__